// extracted by mini-css-extract-plugin
module.exports = {"roomsContainer":"Rooms_roomsContainer__w2Cra","roomTitle":"Rooms_roomTitle__382Az"};